import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../features/slices/applicationSlice";
import { TFunction } from "i18next";

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showConfirmEditWorkerAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.edit.title'),
                message: translate('alerts.edit.message'),
                icon: 'info',
                confirmText: translate('alerts.edit.confirmText'),
                cancelText: translate('alerts.edit.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    return {
        showConfirmEditWorkerAlert
    };
};

export default useAlerts;